import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Skeleton,
  Box,
  Container,
} from "@mui/material";

/**
 * StoresFilterBarSkeleton Component
 *
 * Loading skeleton for the Stores filter bar
 */
export const StoresFilterBarSkeleton: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          mb: 4,
          p: { xs: 1.5, sm: 3 },
          background: "white",
          borderRadius: 3,
          boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
          border: "1px solid rgba(0,0,0,0.06)",
        }}
      >
        <Grid container spacing={{ xs: 1.5, sm: 2 }} alignItems="center">
          <Grid item xs={12} md={4}>
            <Skeleton variant="rounded" height={40} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Skeleton variant="rounded" height={40} />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Skeleton variant="rounded" height={40} />
          </Grid>
          <Grid item xs={12} md={3}>
            <Skeleton variant="rounded" height={40} />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

/**
 * StoresSkeleton Component
 *
 * Loading skeleton for the stores grid
 */
const StoresSkeleton: React.FC = () => {
  return (
    <Grid container spacing={3}>
      {[...Array(8)].map((_, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          <Card sx={{ height: "100%" }}>
            <Skeleton variant="rectangular" height={140} />
            <CardContent sx={{ p: 2 }}>
              <Skeleton
                variant="text"
                width="70%"
                sx={{ fontSize: "1.25rem", mb: 1 }}
              />
              <Skeleton variant="text" width="50%" sx={{ mb: 1.5 }} />
              <Skeleton
                variant="rounded"
                width="60%"
                height={24}
                sx={{ borderRadius: 3 }}
              />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default StoresSkeleton;
